// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__PtcxJ","dragIcon":"Choice_dragIcon__azMDM","left":"Choice_left__kOnwL","input":"Choice_input__K3NrD"};